import { DeviceType } from '../../../utils/index.js';
import { Site } from '../enum/index.js';
/**
 * `siteDirectory` object holds all brand site configurations
 */
const siteDirectory = {
    [Site.ALLRECIPES]: {
        siteCode: 'AR',
        clientIds: {
            [DeviceType.DESKTOP]: '36381536f4fa5e641cc6649a4ad959ec',
            [DeviceType.MOBILE]: 'dd7f11c8b986d3f433a6486030da579e',
            [DeviceType.TABLET]: 'ee7e8854a969ce746a4d792684ff66b5',
            PRINT: '489e9ab043c0ffc26cb47cc80e42cb5a'
        },
        primaryColor: '#D54215',
        secondaryColor: '#E7AB46',
        tertiaryColor: '#F5F6EA',
        ignoredIngredientIds: [
            '2496',
            '4483',
            '1780',
            '3076',
            '20382',
            'd41d8cd98f00b204e9800998ecf8427e'
        ],
        recipeSourceId: 224,
        instacartEnabled: true,
        amazonFreshEnabled: true,
        wholeFoodsEnabled: true
    },
    [Site.BETTER_HOMES_GARDENS]: {
        siteCode: 'BHG',
        clientIds: {
            [DeviceType.DESKTOP]: '52775a1a2d9f31aa096fe9ee5701c589',
            [DeviceType.MOBILE]: 'e5a3053e31622577da29f6bc5d693f2d',
            [DeviceType.TABLET]: '48024c54ff524f0505b7018fad9e3415',
            PRINT: ''
        },
        primaryColor: '#4B4FAA',
        secondaryColor: '#C83AA2',
        tertiaryColor: '#F1F2FF',
        ignoredIngredientIds: [
            '2496', // Water
            '20382' // Ice
        ],
        recipeSourceId: 263,
        instacartEnabled: false,
        amazonFreshEnabled: false,
        wholeFoodsEnabled: false
    },
    [Site.EATING_WELL]: {
        siteCode: 'EW',
        clientIds: {
            [DeviceType.DESKTOP]: '9f0d5dbf0667334db2479ee1a5c6b4a2',
            [DeviceType.MOBILE]: '198a5cc7d2a857a3b647317e8e6cad0a',
            [DeviceType.TABLET]: '8c021b7677b9e51782c94ee873cfa0d8',
            PRINT: ''
        },
        primaryColor: '#006646',
        secondaryColor: '#619E45',
        tertiaryColor: '#E4F1EF',
        ignoredIngredientIds: [
            '2496', // Water
            '20382', // Ice
            '4211',
            '4483',
            '1780',
            '2496'
        ],
        recipeSourceId: 257,
        instacartEnabled: true,
        amazonFreshEnabled: true,
        wholeFoodsEnabled: true
    },
    [Site.FOOD_AND_WINE]: {
        siteCode: 'FW',
        clientIds: {
            [DeviceType.DESKTOP]: '933ddc2b44f97ffd01ce7ce03aaf81f4',
            [DeviceType.MOBILE]: '120e3499685d9edba59ca2ccf60f3d9c',
            [DeviceType.TABLET]: '042cdd50cce9ba602014d998ab356d06',
            PRINT: ''
        },
        primaryColor: '#E71F3D',
        secondaryColor: '#4294FF',
        tertiaryColor: '#EEEEF0',
        ignoredIngredientIds: [
            '2496', // Water
            '20382', // Ice
            '4483',
            '1780',
            '3076',
            '0771374fff7db59dc9254d2c77cba526',
            '9460370bb0ca1c98a779b1bcc6861c2c',
            '768996933ad265e9c9fd4b732742835a',
            '9c4d17abe4fe652d5095726334e5118c',
            '7bdff76536f12a7c5ffde207e72cfe3a',
            '1b7eb0fa812799edce20772c051610fc',
            '3209f403d651864914357adf28f5d9dc'
        ],
        recipeSourceId: 272,
        instacartEnabled: true,
        amazonFreshEnabled: true,
        wholeFoodsEnabled: true
    },
    [Site.HEALTH]: {
        siteCode: 'HEALTH',
        clientIds: {
            [DeviceType.DESKTOP]: '95df8b444200a0a3652f31f96e35da90',
            [DeviceType.MOBILE]: '4d16f4538745e036077dc80ed12f0ca2',
            [DeviceType.TABLET]: '0e3b48269aea92366985c552acba1cd8',
            PRINT: ''
        },
        primaryColor: '#1a7f82',
        secondaryColor: '#fbd9ce',
        tertiaryColor: '',
        ignoredIngredientIds: [
            'dfae4acad8dc26b42297119bf0866c55', // Water
            'aa4671be2814999b547f258f7b140d17' // Ice
        ],
        recipeSourceId: 277,
        instacartEnabled: false,
        amazonFreshEnabled: false,
        wholeFoodsEnabled: false
    },
    [Site.MARTHA_LIVING]: {
        siteCode: 'MSLO',
        clientIds: {
            [DeviceType.DESKTOP]: 'fb544dc1c3bdabeae82aa18681b1e9fb',
            [DeviceType.MOBILE]: '1e6e6558baaa8940f4597e0d0735bc79',
            [DeviceType.TABLET]: 'e8dd7c7a81ab26016358f5f3d4ea3f14',
            PRINT: ''
        },
        primaryColor: '#99261e',
        secondaryColor: '#f5f6ea',
        tertiaryColor: '',
        ignoredIngredientIds: [
            '2496', // Water
            '20382' // Ice
        ],
        recipeSourceId: 255,
        instacartEnabled: false,
        amazonFreshEnabled: false,
        wholeFoodsEnabled: false
    },
    [Site.MIDWEST_LIVING]: {
        siteCode: 'MWL',
        clientIds: {
            [DeviceType.DESKTOP]: '2df6c37e7ba46be60da5a1ec5ccfd9d4',
            [DeviceType.MOBILE]: 'ce69c31a45f9df6f12052ef79dd46728',
            [DeviceType.TABLET]: 'a5c73ebfb52a2db083205d29e2de3f0a',
            PRINT: ''
        },
        primaryColor: '#d54215',
        secondaryColor: '#f44336',
        tertiaryColor: '',
        ignoredIngredientIds: [
            '2496', // Water
            '20382' // Ice
        ],
        recipeSourceId: 268,
        instacartEnabled: true,
        amazonFreshEnabled: true,
        wholeFoodsEnabled: true
    },
    [Site.MYRECIPES]: {
        siteCode: 'MR',
        clientIds: {
            [DeviceType.DESKTOP]: '07f685b3f90f720dba1832e31fbd30d7',
            [DeviceType.MOBILE]: 'fd35fe8b30c3c8bc5465faf741ef99c3',
            [DeviceType.TABLET]: '09f3d6888e3dbfaddc35bdbb62801178',
            PRINT: ''
        },
        primaryColor: '#006165',
        secondaryColor: '#99c6c7',
        tertiaryColor: '',
        ignoredIngredientIds: [
            '2496', // Water
            '20382', // Ice
            '9460370bb0ca1c98a779b1bcc6861c2c', // Water
            '9c4d17abe4fe652d5095726334e5118c' // Boiling water
        ],
        recipeSourceId: 274,
        instacartEnabled: true,
        amazonFreshEnabled: true,
        wholeFoodsEnabled: true
    },
    [Site.PEOPLE_ESP]: {
        siteCode: 'PESP',
        clientIds: {
            [DeviceType.DESKTOP]: 'f8eb0ed91c43df7d474082b690db0615',
            [DeviceType.MOBILE]: '28939c7f148d63f257c8409a32deb5a7',
            [DeviceType.TABLET]: '008e3be934e969e23b66a602e39e59b4',
            PRINT: ''
        },
        primaryColor: '#006165',
        secondaryColor: 'rgb(153,198,199)',
        tertiaryColor: '',
        ignoredIngredientIds: [''],
        recipeSourceId: 273,
        instacartEnabled: false,
        amazonFreshEnabled: false,
        wholeFoodsEnabled: false
    },
    [Site.PARENTS]: {
        siteCode: 'PARENTS',
        clientIds: {
            [DeviceType.DESKTOP]: '8135eb8bfaab54d8e4771422f4a25219',
            [DeviceType.MOBILE]: 'a75ba8c960498964e94bcac60e40abd4',
            [DeviceType.TABLET]: '4ce01fcb480fb79270c3d18dec14f045',
            PRINT: ''
        },
        primaryColor: '#4775ff',
        secondaryColor: 'rgb(254, 224, 207)',
        tertiaryColor: '',
        ignoredIngredientIds: [
            '2496', // Water
            '20382' // Ice
        ],
        recipeSourceId: 279,
        instacartEnabled: false,
        amazonFreshEnabled: false,
        wholeFoodsEnabled: false
    },
    [Site.RACHAEL_RAY_MAG]: {
        siteCode: '', // none set in legacy Andromeda
        clientIds: {
            [DeviceType.DESKTOP]: '1b5203a86bd71a66abae6216a61cf101',
            [DeviceType.MOBILE]: 'd17e22aa76756fe8f8d168aeb3a9745a',
            [DeviceType.TABLET]: '5f79b1200bd8463b5e16cc94ffcb0bdc',
            PRINT: ''
        },
        primaryColor: '#e5106c',
        secondaryColor: '#f9cfe1',
        tertiaryColor: '',
        ignoredIngredientIds: [
            '2496', // Water
            '20382' // Ice
        ],
        recipeSourceId: 278,
        instacartEnabled: false,
        amazonFreshEnabled: false,
        wholeFoodsEnabled: false
    },
    [Site.REAL_SIMPLE]: {
        siteCode: 'RS',
        clientIds: {
            [DeviceType.DESKTOP]: '48c66f9ba763f6c43ff7d91771e1622c',
            [DeviceType.MOBILE]: '2d60e5102ea1f4721ef9101bd57b17ea',
            [DeviceType.TABLET]: '3cd070b5cfbff1c14fcf38b164705c6e',
            PRINT: ''
        },
        primaryColor: '#e5106c',
        secondaryColor: '#f9cfe1',
        tertiaryColor: '',
        ignoredIngredientIds: [
            '2496', // Water
            '20382' // Ice
        ],
        recipeSourceId: 269,
        instacartEnabled: false,
        amazonFreshEnabled: false,
        wholeFoodsEnabled: false
    },
    [Site.SOUTHERN_LIVING]: {
        siteCode: 'SOL',
        clientIds: {
            [DeviceType.DESKTOP]: '0918f209ded8bc7a548c855c60463e8a',
            [DeviceType.MOBILE]: 'c154b496f807ec5b190b6f199054b839',
            [DeviceType.TABLET]: '07711db0537267aea2f1aa983d818a7c',
            PRINT: ''
        },
        primaryColor: '#99261e',
        secondaryColor: '#f5f6ea',
        tertiaryColor: '#',
        ignoredIngredientIds: [
            'dfae4acad8dc26b42297119bf0866c55', // Water
            'aa4671be2814999b547f258f7b140d17' // Ice
        ],
        recipeSourceId: 270,
        instacartEnabled: false,
        amazonFreshEnabled: false,
        wholeFoodsEnabled: false
    },
    [Site.SHAPE]: {
        siteCode: 'SHAPE',
        clientIds: {
            [DeviceType.DESKTOP]: '814affd21a3e68a845dac230b4a5bd2d',
            [DeviceType.MOBILE]: 'b2105a6782827f9728619e07bd7d65a9',
            [DeviceType.TABLET]: '91660aa41b2eb3de5f283e4b7401f0a6',
            PRINT: ''
        },
        primaryColor: '#99261e',
        secondaryColor: '#f5f6ea',
        tertiaryColor: '',
        ignoredIngredientIds: [
            'dfae4acad8dc26b42297119bf0866c55', // Water
            'aa4671be2814999b547f258f7b140d17' // Ice
        ],
        recipeSourceId: 276,
        instacartEnabled: false,
        amazonFreshEnabled: false,
        wholeFoodsEnabled: false
    },
    [Site.LOCAL]: {
        /**
         *  LOCAL uses AllRecipes site details...
         */
        siteCode: 'LOCAL',
        clientIds: {
            [DeviceType.DESKTOP]: '36381536f4fa5e641cc6649a4ad959ec',
            [DeviceType.MOBILE]: 'dd7f11c8b986d3f433a6486030da579e',
            [DeviceType.TABLET]: 'ee7e8854a969ce746a4d792684ff66b5',
            PRINT: '489e9ab043c0ffc26cb47cc80e42cb5a'
        },
        primaryColor: '#D54215',
        secondaryColor: '#E7AB46',
        tertiaryColor: '#F5F6EA',
        ignoredIngredientIds: ['2496', '20382'],
        recipeSourceId: 224,
        instacartEnabled: true,
        amazonFreshEnabled: true,
        wholeFoodsEnabled: true
    }
};
export const getSiteConfiguration = (site) => {
    const siteDetails = siteDirectory[site];
    return siteDetails;
};
